import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=72afdc60&scoped=true"
import script from "./editor.vue?vue&type=script&lang=ts"
export * from "./editor.vue?vue&type=script&lang=ts"
import style0 from "@/styles/editor.scss?vue&type=style&index=0&id=72afdc60&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72afdc60",
  null
  
)

export default component.exports